// extracted by mini-css-extract-plugin
export var dataCell = "_ro-2";
export var dataRow = "_ro-0";
export var headerRow = "_ro-1";